














import {defineComponent} from "@vue/composition-api"

export default defineComponent({
    name: "Crumbs",
    props: {
        range: {
            type: Number,
            required: true,
            default: 1
        },
        current: {
            type: Number,
            required: true,
            default: 0
        }
    }
})
